module.exports = __webpack_public_path__ + "static/img/detect02.727a65f.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/detect02.png
// module id = 576
// module chunks = 4